import Home from './home';
// import Android from './android';
// import Ios from './ios';
import Guide from './guide';
import { isOnIPhone } from '@/lib/utils';
// import getSiteConfig from '../../siteConfig.js';
// import {isOnIPhone, setNewsit} from '@/lib/utils';
// const siteConfig = getSiteConfig(process.env.SITE_ID);
var mods = [];
if (isOnIPhone) {
    mods = [
        {
            key: 'home',
            Component: Home
        },
        {
            key: 'guide',
            Component: Guide
        }
    ];
}
else {
    mods = [
        {
            key: 'home',
            Component: Home
        }
    ];
}
export default mods;
